export default {
  // reference data
  getHostReferenceData: state => state.hostReferenceData,
  getTenantReferenceData: state => state.tenanteReferenceData,

  // feature
  getInvoiceSettings: state => state.invoiceSettings,
}
